import React,{ useState } from 'react'

import axios from 'axios';

import { Delete,Add,Remove,LocalMall } from '@mui/icons-material';
import { Typography,Radio,Box,Button } from '@mui/material';
import {Dialog,DialogActions,DialogTitle,DialogContent,Grid,Card,CardHeader,CardContent,CardActions,IconButton,TextField,CssBaseline,Stack,Paper } from '@mui/material';
import Slide from '@mui/material/Slide';
import Loader from '../Tools/Loader';
import Alerts from '../Tools/Alerts';
import {List,ListItemSecondaryAction,ListItem,ListItemAvatar,ListItemText} from '@mui/material';
import moment from "moment";
import Avatar from '@mui/material/Avatar';
import { connect } from 'react-redux';
import { numberFormat } from "../Tools/FormatNumber";
import {delDataCart,setDataCart,RemDataCart} from '../../../Actions/DataCart';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Cart = (props) => {

  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState('P-001');
  const [alerto, setAlerto] = useState('');
  const ref = React.useRef(null);
  const datenow = moment().format(' dddd , MMMM Do YYYY');

  const [open, setOpen] = useState(false)

  const [open_payment_pos, setOpenPaymentPos] = useState(false)
  const [open_qr_payment, setOpenQrPayment] = useState(false)
  const [detail_qr, setDetailQR] = useState('');
  //const { DataCarts } = props;
  
	//console.log(props.logindata)
	
	const result_sum = props.DataCarts.reduce((total, currentValue) => total = total + (currentValue.final_price*currentValue.amount),0);
	
	const handleCloseAlerto = () => {
		setAlerto(false);
	  };
	const SimpanDataUser = async (event) => {
		event.preventDefault();
		const data = new FormData(event.currentTarget);
		let user_email = data.get('user_email')
		let user_phone = data.get('user_phone')
		await localStorage.setItem('user_email', user_email)
		await localStorage.setItem('user_phone', user_phone)
		setOpen(false)
		setOpenPaymentPos(true)
	}
	
	const SimpanDataPaymentPos = async (event) => {
		event.preventDefault();
		setLoading(true)
		
		try { 
			const user_email= await localStorage.getItem('user_email')
			const user_phone= await localStorage.getItem('user_phone')
			const data_cart = {
				"data_transaction": [{
					"user_email": user_email,
					"user_phone": user_phone,
					"id_payment": value,
					"total_amount": result_sum,
				}],
				"details": props.DataCarts
			}
			console.log(data_cart)
            var api='https://node.ladokutu.info/index.php/Posc/add_data_transaction_pos';  
			const response = await axios({
                  method: 'post',
                  url: api,
                  data: data_cart
				});
			console.log(response.data)

			if ((response.data.status === 200)&&(value === 'P-001')){
				setOpenPaymentPos(false)
				props.RemDataCart()
			}else if ((response.data.status === 200)&&(value === 'P-002')){
				setOpenPaymentPos(false)
				setDetailQR(response.data.detail_qr)
				props.RemDataCart()
				setOpenQrPayment(true)
			}
				//event.current.reset()
			setAlerto({
				alerto: true,
				state_msg: response.data.message,
				state_typ: response.data.type
			});
			setLoading(false)
        } catch (error) {
			setAlerto({
			  alerto: true,
			  state_msg: 'Data Error',
			  state_typ:'error'
			});
			setLoading(false)
            console.log(error)
        }

	}

	const handleChange = (event) => {
		setValue(event.target.value);
	};
  return (
    <>
	   <Loader loading={loading} />
	   <Alerts  alerto={alerto.alerto} state_typ={alerto.state_typ} state_msg={alerto.state_msg} onClose={handleCloseAlerto} />
	   <Box sx={{ pb: 7 }} ref={ref}>	
	   <CssBaseline />
			
				<Grid container
				  spacing={0}
				  direction={{ xs: 'column', md: 'row' }}
				  justifyContent={{ xs: 'center', md: 'center' }}
				  alignItems={{ xs: 'center', md: 'center' }}>
					<Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
						<Card>
						<CardHeader
							title="Shooping Chart"
							subheader={datenow}
						  />
						<CardContent>
						<List >
						{props.DataCarts.map((item, index) => (
						  <ListItem button key={index} 
						  >
							<ListItemSecondaryAction>
								<IconButton edge="end" aria-label="add" onClick={()=>props.setDataCart(++item.amount )}>
								  <Add />
								</IconButton>
								<IconButton edge="end" aria-label="Remove" onClick={()=>props.setDataCart(--item.amount)}>
								  <Remove />
								</IconButton>
								<IconButton edge="end" aria-label="delete" onClick={()=>props.delDataCart(item)} color='error'>
								  <Delete />
								</IconButton>
							</ListItemSecondaryAction>
							<ListItemAvatar>
							  <Avatar alt="Profile Picture" src={item.picture} />
							</ListItemAvatar>
							
							<ListItemText primary={item.item_name} 
								secondary={ numberFormat(item.final_price)+" X  "+item.amount +" = "+numberFormat((item.final_price)*item.amount) } 
							/>
						  </ListItem>
						  
						))}
						</List>
						</CardContent>
						{props.logindata ?
						<CardActions>
							<Grid container justifyContent="center">
								{ result_sum > 0 ?
								<Button variant="outlined" startIcon={<LocalMall />} onClick={()=> setOpenPaymentPos(true)}>
									Check Out
								</Button>
								:null}
								<IconButton sx={{  marginLeft: 'auto' }} aria-label="Let's Shopping">
									 Total : {numberFormat(result_sum)}
								</IconButton>
							</Grid>
						</CardActions>
						:
						<CardActions>
							<Grid container justifyContent="center">
								{ result_sum > 0 ?
								<Button variant="outlined" startIcon={<LocalMall />} onClick={()=> setOpen(true)}>
									Check Out
								</Button>
								:null}
								<IconButton sx={{  marginLeft: 'auto' }} aria-label="Let's Shopping">
									 Total : {numberFormat(result_sum)}
								</IconButton>
							</Grid>
						</CardActions>
						}
						</Card>
					</Grid>
				</Grid>
			<Dialog
				open={open}
				onClose={()=> setOpen(false)}
				TransitionComponent={Transition}
				maxWidth='md'
				aria-describedby="alert-dialog-slide-description"
			  >
				<DialogTitle>Fill Information</DialogTitle>
				<Box component="form" onSubmit={SimpanDataUser}  sx={{ mt: 1 }}>
				<DialogContent dividers>
						
					<Grid container spacing={1}>
					  
					  <Grid item xs={12}>
						<TextField margin="normal" type="email" required fullWidth size="small" name="user_email" id="user_email" label="E-Mail"  />
					  </Grid>
					  <Grid item xs={12}>
						<TextField margin="normal" type="number" required fullWidth size="small" name="user_phone" id="user_phone" label="Phone" inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }} />
					  </Grid>
					</Grid>
					
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={()=> setOpen(false)}>Close</Button>
					<Button color="success" variant="contained" type="submit">Submit</Button>
				</DialogActions>
				</Box>
			  </Dialog>	
			  	
			<Dialog
				open={open_payment_pos}
				onClose={()=> setOpenPaymentPos(false)}
				TransitionComponent={Transition}
				 maxWidth='md'
				aria-describedby="alert-dialog-slide-description"
			  >
				<DialogTitle>Payment Method </DialogTitle>
				<Box component="form" onSubmit={SimpanDataPaymentPos}  sx={{ mt: 1 }}>
				<DialogContent dividers>
						
					<Grid container spacing={1}  >
					  
					  <Grid item xs={12} >
						<Typography gutterBottom variant="h5" component="div" alignItems="center" justifyContent="center">
							Total : {numberFormat(result_sum)}
						</Typography>
					  </Grid>
					  <Grid item xs={12} >
						<Box
							  sx={{
								justifyContent: 'center',  
								display: 'flex',
								flexWrap: 'wrap',
								'& > :not(style)': {
								  m: 1,
								  width: 128,
								  height: 128,
								},
							  }}
						>  
						 <Paper elevation={3} >
							<Stack
							  direction="column"
							  justifyContent="space-between"
							  alignItems="center"
							  spacing={5}
							>
							  <Stack direction="row" spacing={2}>
								<Radio checked={value === 'P-001'} onChange={handleChange} value="P-001"/>
								<Avatar alt="Cash" src="https://node.ladokutu.info/include/images/cash.png" sx={{ width: 56, height: 56 }} />
							  </Stack>
							  <Typography align="center">Cash</Typography>
							</Stack>
						  </Paper>


						 <Paper elevation={3} >
							<Stack
							  direction="column"
							  justifyContent="space-between"
							  alignItems="center"
							  spacing={5}
							>
							  <Stack direction="row" spacing={2}>
								<Radio checked={value === 'P-002'} onChange={handleChange} value="P-002"/>
								<Avatar alt="QRIS" src="https://node.ladokutu.info/include/images/qris.png" sx={{ width: 56, height: 56 }} />
							  </Stack>
							  
							  <Typography align="center">QRIS</Typography>
							 </Stack>
						  </Paper>
						  
						  
						</Box>
						
						
					  </Grid>
					  
					</Grid>
					
					
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={()=> setOpenPaymentPos(false)}>Close</Button>
					<Button color="success" variant="contained" type="submit">Submit</Button>
				</DialogActions>
				</Box>
			</Dialog>
			
			
			
			<Dialog
				open={open_qr_payment}
				onClose={()=> setOpenQrPayment(false)}
				TransitionComponent={Transition}
				 maxWidth='md'
				aria-describedby="alert-dialog-slide-description"
			  >
				<DialogTitle>QR Payment </DialogTitle>
				<Box component="form" onSubmit={SimpanDataPaymentPos}  sx={{ mt: 1 }}>
				<DialogContent dividers>	
					<Grid container spacing={1}  >
					  <Grid item xs={12} >
						<Box
							  sx={{
								justifyContent: 'center',  
								display: 'flex',
								flexWrap: 'wrap',
								'& > :not(style)': {
								  m: 1,
								  width: 128,
								  height: 128,
								},
							  }}
						>  
						<Avatar alt="QRIS" src={detail_qr} sx={{ width: 56, height: 56 }} variant="square" />
						</Box>
					  </Grid>
					</Grid>
				</DialogContent>
				<DialogActions>
					<Button variant="outlined" onClick={()=> setOpenQrPayment(false)}>Close</Button>
				</DialogActions>
				</Box>
			</Dialog>
	  </Box>
	  
	  
	  
	</>  
    
  );
}

const mapStateToProps = (state) => {
  const {DataCarts,logindata} = state;
  return {
	DataCarts:DataCarts,
	logindata:logindata,
  };
};
const mapDispatchToProps = (dispatch) => ({
  setDataCart: (value) => dispatch(setDataCart(value)),
  delDataCart: (value) => dispatch(delDataCart(value)),
  RemDataCart: () => dispatch(RemDataCart()),
});
export default connect( mapStateToProps,mapDispatchToProps)(Cart);